class subCollection extends HTMLElement {
  constructor() {
      super();

      const self = this;

      const collectionId = document.querySelector("#ProductGridContainer").getAttribute('data-section-id');
      const collectionListSectionId = document.querySelector("#collectionListSection").getAttribute('data-section-id');
      const collectionBanner = document.querySelector("#collectionBanner").getAttribute('data-section-id');
      const collectionTextImg = document.querySelector("#collectionTextImg").getAttribute('data-section-id');

      this.sections = {
          collectionHandleList: {
              sectionId: collectionListSectionId,
              nodeId: "collectionListSection"
          },
          collectionBanner: {
            sectionId: collectionBanner,
            nodeId: "collectionBanner"
          },
          main: {
              sectionId: collectionId,
              nodeId: "ProductGridContainer"
          },
          collectionTextImg: {
            sectionId: collectionTextImg,
            nodeId: "collectionTextImg"
          }
      };

      this.ajaxCollectionEl = document.querySelector(`#${this.sections.main.nodeId}`);
      this.ajaxCollectionHandleListEl = document.querySelector(`#${this.sections.collectionHandleList.nodeId}`);
      this.ajaxCollectionBannerEl = document.querySelector(`#${this.sections.collectionBanner.nodeId}`);
      this.ajaxcollectionTextImgEl = document.querySelector(`#${this.sections.collectionTextImg.nodeId}`);
      this.subCollectionItems = this.querySelectorAll("[js-sub-collection-item]");

      this.subCollectionItems.forEach( item => {
          item.addEventListener('click', function(e) {
              e.preventDefault();
              const collectionHandle = this.dataset.collectionHandle;
              self.initAjaxCollection(collectionHandle);
          })
      });

  };

  initAjaxCollection(handle) {
      this.updateHistoryState(handle);
      this.renderAjaxCollectionBanner(handle);
      this.renderAjaxcollectionTextImg(handle);
      this.renderAjaxCollection(handle);
      this.renderAjaxCollectionHandleList(handle);
  };

  updateHistoryState(handle) {
       var newurl = `${window.location.protocol}//${window.location.host}/collections/${handle}`;
      if(location.pathname.includes('/en-')) {
        const getCountryCode = location.pathname.split('/');
        newurl = `${window.location.protocol}//${window.location.host}/${getCountryCode[1]}/collections/${handle}`;
      }
    
      window.history.replaceState({path: newurl}, '', newurl);
  };

  renderAjaxCollectionBanner(handle) {
    const self = this;
    let url = `/collections/${handle}?section_id=${this.sections.collectionBanner.sectionId}`;
    if(location.pathname.includes('/en-')) {
        const getCountryCode = location.pathname.split('/');
        url = `/${getCountryCode[1]}/collections/${handle}?section_id=${this.sections.collectionBanner.sectionId}`;
    }
 
    fetch(url).then(function(response) {
        return response.text();
    }).then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
       
        self.ajaxCollectionBannerEl.innerHTML = doc.querySelector(`#${self.sections.collectionBanner.nodeId}`).innerHTML;
      
    });
  }

  renderAjaxcollectionTextImg(handle) {
    const self = this;
    let url = `/collections/${handle}?section_id=${this.sections.collectionTextImg.sectionId}`;

    if(location.pathname.includes('/en-')) {
        const getCountryCode = location.pathname.split('/');
        url = `/${getCountryCode[1]}/collections/${handle}?section_id=${this.sections.collectionTextImg.sectionId}`;
    }

    fetch(url).then(function(response) {
        return response.text();
    }).then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
       
        self.ajaxcollectionTextImgEl.innerHTML = doc.querySelector(`#${self.sections.collectionTextImg.nodeId}`).innerHTML;
      
    });
  }

  renderAjaxCollectionHandleList(handle) {
    const self = this;
    let url = `/collections/${handle}?section_id=${this.sections.collectionHandleList.sectionId}`;
    if(location.pathname.includes('/en-')) {
        const getCountryCode = location.pathname.split('/');
        url = `/${getCountryCode[1]}/collections/${handle}?section_id=${this.sections.collectionHandleList.sectionId}`;
    }

    fetch(url).then(function(response) {
        return response.text();
    }).then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        self.ajaxCollectionHandleListEl.innerHTML = doc.querySelector(`#${self.sections.collectionHandleList.nodeId}`).innerHTML;
      
    });
  }

  renderAjaxCollection(handle) {
      const self = this;
      let url = `/collections/${handle}?section_id=${this.sections.main.sectionId}`;
      if(location.pathname.includes('/en-')) {
          const getCountryCode = location.pathname.split('/');
          url = `/${getCountryCode[1]}/collections/${handle}?section_id=${this.sections.main.sectionId}`;
      }
      fetch(url).then(function(response) {
          return response.text();
      }).then(function(html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');

          self.ajaxCollectionEl.innerHTML = doc.querySelector(`#${self.sections.main.nodeId}`).innerHTML;
        
      });
  }
}

customElements.define('sub-collection', subCollection);
